export enum EmailCredentialsTypeEnum {
  GmailOauthRefreshToken = 'GMAIL_OAUTH_REFRESH_TOKEN',
  MicrosoftOauthRefreshToken = 'MICROSOFT_OAUTH_REFRESH_TOKEN',
}
